import { createReducer } from "@reduxjs/toolkit";
import { reopenEndStep, reopenSetShowHeader } from "./actions";

export type ReopenReducerType = {
	showHeader: boolean | undefined;
	endSteps: boolean;
};

const initialState: ReopenReducerType = {
	showHeader: undefined,
	endSteps: false,
};

export const ReopenReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(reopenSetShowHeader, (state, action) => {
			state.showHeader = action.payload;
		})
		.addCase(reopenEndStep, (state, action) => {
			state.endSteps = action.payload;
		});
});
